import React from "react";
import {configureStore} from "./redux/store";

// NOTE: Exports defined in this file so they won't create multiple rendering with hot reload

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  static getDerivedStateFromError(error) {
    return {error};
  }

  render() {
    const {FallbackComponent, children} = this.props;
    const {error} = this.state;
    if (error) {
      return FallbackComponent ? <FallbackComponent error={error}/> : null;
    }
    return children;
  }
}

export const store = configureStore();
